<template>
  <div>

<div class="container privacy-style" id="container-1">
  <div class="row bar">
        <div class="col-12 col-md-5">
          <div class="d-flex justify-content-between mb-1">
            <div class="col-auto bg-n-red">隱私權政策</div>
            <div class="col bg-n-gray text-left">PRIVACY</div>

          </div>
        </div>
       
      </div>
  <!-- <h1>隱私權政策</h1> -->
  <p><span >久億光電科技有限公司</span>尊重與保障隱私權，範圍包含員工、客戶、供應商等相關利害關係人，所有廠區皆遵循當地區域、國家以及國際標準，並制定企業行為準則及管理文件，將其內化於管理系統中，且遊說、規範合作夥伴及供應商亦應符合相關規定。</p>
  <h2>隱私權政策</h2>
  <p><span >久億光電科技有限公司</span>十分尊重公司網站使用者的隱私權，為能讓您了解本公司於公司網站中資訊蒐集、使用及處理等相關事項，請您仔細閱讀以下本公司隱私權政策相關內容，我們希望能讓使用者清楚瞭解本公司資訊蒐集、使用方式及隱私權保障的各項措施。</p>
  <p>若您繼續瀏覽本公司網站或將個人資料提供與我們，將被視為您接受本隱私權政策。</p>
  <h2>個人資訊之蒐集</h2>
  <p>使用本公司網站，並不一定要求個人資訊之提供；但本公司網站的某些服務或功能，可能會收集用來識別特定個人的資訊，如您的姓名、地址、連絡電話、電子郵件地址及其他聯絡方式等。</p>
  <p>此外，本公司網站亦可能自動收集使用者瀏覽網站時之相關附帶資訊，例如您的網際網路協定位址（IP）、瀏覽器類型、電腦作業系統等，或以Cookies、網路信標(Web beacon)等技術收集您使用本公司相關網頁之資訊，例如使用次數、使用時間等。</p>
  <h2>我們如何使用您的資訊</h2>
  <p>我們所蒐集到的個人資訊，將可能在回覆您的需求、發送郵件和提供電子報、或提供您所要求的服務時使用；此外，我們也可能使用蒐集到的部分資訊，以協助改善本公司網站內容及服務品質。</p>
  <p>除非是為了向您提供您所要求的服務、獲得您的授權或下列情況外，否則我們不會揭露、銷售或提供給任何其他人士或非關係企業您的個人資料，或與之分享。</p>
  <p>我們可能會將部分資訊提供給我們的管理者、被授權或業務相關之員工或關係企業做為參考（如履歷資訊將提供我們人力資源部參考使用）或被授權之網頁設計廠商作為本公司網站維護、擴充時之參考，前述資料之提供皆遵守本隱私權政策及其他適當的保密和安全措施。此外，若因法令要求、法院或相關執行機關的命令、或本公司為確保遵守法定義務及保護久億光電科技有限公司財產及權利的範圍內，我們也可能會揭露我們所收集到的個人資訊。</p>
  <h2>個人資訊之維護及刪除</h2>
  <p>若您希望更改您的個人資訊、停止收到我們提供的資訊、或希望自本公司網站資料庫中刪除您的個人資訊，請以電子郵件方式與我們聯繫<span >kuan0124@gmail.com</span>，我們將盡快為您處理。</p>
  <h2>隱私權政策更新</h2>
  <p><span >久億光電科技有限公司</span>將不定期修訂本隱私權政策，您可以從下方最後修改日期上知道隱私權政策最新之修改版本及日期。建議您不定期造訪本公司網站，瀏覽最新的隱私權政策，以了解其相關內容。</p>
</div>
      
  </div>
</template>


<script>


export default {
  data(){
    return{

      a: [
        {
          xs: "/static/privacy/768/1.jpg",
          sm: "/static/privacy/768/1.jpg",
          md: "/static/privacy/768/1.jpg",
          lg: "/static/privacy/768/1.jpg",
          xl: "/static/privacy/1200/1.jpg"
        }
      ]
    }
  },
  methods: {
    
    pusha() {
      let vm = this;
      vm.$emit("pusha", vm.a);
    }
  },
  created: function() {
    this.pusha()
  },
  mounted: function() {

  },
  components:{
    
  }
}
</script>

<style lang="sass" scoped>
@import "~bootstrap/scss/bootstrap"
.privacy-style
  text-align: left
  // padding-top: 65px
  // padding-bottom: 100px
  h1
    font-size: 43px
    margin-bottom: 45px
  h2
    margin-bottom: 45px
    font-size: 22px
    font-weight: 700
  p
    margin-bottom: 45px
    font-size: 16px
span
  color: rgb(175, 40, 45)
  font-weight: bold
.bar
  @include media-breakpoint-up(xl)
    margin-bottom: 50px
  @include media-breakpoint-up(xl)
    margin-bottom: 16px
.bg-n-red
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(182, 40 ,44)
  color: white
  text-align: center
  padding-top: 7px
  padding-bottom: 7px
.bg-n-gray
  @include media-breakpoint-up(xs)
    font-size: 14px
  @include media-breakpoint-up(xl)
    font-size: 25px
  background-color: rgb(51, 58, 64)
  color: white
  padding-left: 13px
  padding-top: 7px
  padding-bottom: 7px 
#container-1
  @include media-breakpoint-up(xl)
    padding-top: 118px
    padding-bottom:  212px
  @include media-breakpoint-up(xs)
    padding-top: 46px
    padding-bottom:  146px
</style>




// WEBPACK FOOTER //
// src/components/Privacy.vue